module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"close shadowed\"><i class=\"icon-close\"></i></div> <div class=\"wrapper-message clearfix\"> <% if(headline1) { %><h1><%- headline1 %></h1><% } %> <% if(headline2) { %><h2><%- headline2 %></h2><% } %> <% if(paragraph1) { %><p><%- paragraph1 %></p><% } %> <% if(paragraph2) { %><p><%- paragraph2 %></p><% } %> <% if(paragraph3) { %><p><%- paragraph3 %></p><% } %> </div> "
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"close shadowed\"><i class=\"icon-close\"></i></div> <div class=\"wrapper-message clearfix\"> ")
    ;  if(headline1) { 
    ; __append("<h1>")
    ; __append( headline1 )
    ; __append("</h1>")
    ;  } 
    ; __append(" ")
    ;  if(headline2) { 
    ; __append("<h2>")
    ; __append( headline2 )
    ; __append("</h2>")
    ;  } 
    ; __append(" ")
    ;  if(paragraph1) { 
    ; __append("<p>")
    ; __append( paragraph1 )
    ; __append("</p>")
    ;  } 
    ; __append(" ")
    ;  if(paragraph2) { 
    ; __append("<p>")
    ; __append( paragraph2 )
    ; __append("</p>")
    ;  } 
    ; __append(" ")
    ;  if(paragraph3) { 
    ; __append("<p>")
    ; __append( paragraph3 )
    ; __append("</p>")
    ;  } 
    ; __append(" </div> ")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}